import type { ReactNode } from 'react';

export function ComoLer({ children }: { children: ReactNode }) {
  return (
    <details className="como-ler">
      <summary>Como ler</summary>
      <div>{children}</div>
    </details>
  );
}
